module.exports = __webpack_public_path__ + "static/team-11-2b02fb9cdd34e79b183ba9c265dc4a55.jpg";